import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import { withRouter } from "react-router-dom";
import './eligibilityLetter.css';
import { put, get, putWithHeadersResponse } from '../../../server/actions';
import {getManageSchoolSettingList, setSchoolYearSettingsToSession} from '../ManageSchools/manageSchoolSettings';

let loginUserInfo = {};
let schoolId = 0;

const lunchProAlert={
    alert:{
        marginBottom:'0px'
    },
    acceptSpan:{
        float:'right'
    },
    acceptBtn:{
        marginTop:'-6px'
    },
    alertText:{
        fontSize:'12px',
        fontStyle: 'italic',
        paddingLeft: '10px'
    }
}

class EditEligibilityLetter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            mealSchoolInfo: {},
            schoolList: [],
            sincerelyText: " ",
            editableContent: " "
        };
    }

    componentDidMount() {
        if(sessionStorage.getItem('ROLE')==='ROLE_SUPERADMIN'){
            schoolId=this.props.school._links.self.href.split('/').pop();
            this.setState({schoolName:'['+this.props.school.schoolName+']'})
        }
        else{
            schoolId=sessionStorage.getItem('SchoolId');
        }
        this.getData();
        this._notificationSystem = this.refs.notificationSystem;
        loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
    }

      componentWillMount = () => {
           if(sessionStorage.getItem('ROLE')==='ROLE_SUPERADMIN'){
            schoolId=this.props.school._links.self.href.split('/').pop();
            this.setState({schoolName:'['+this.props.school.schoolName+']'})
        }
        else{
            schoolId=sessionStorage.getItem('SchoolId');
        }
            this.setState({ loading: true })
            get('/mealSchools/' + schoolId + '/school?access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                console.log('Got School data', data);
                let _userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
                _userInfo.mobileNo = (_userInfo.mobileNo || '').substr(-this.state.mobileLength);
                this.setState({
                    schoolInfo: data,
                    loading: false,
                    userInfo: _userInfo
                }, () => {
                    console.log(this.state.userInfo)
                });
    
            })
                .catch(
                    (error) => {
                        this.setState({
                            loading: false
                        })
                        console.log('Get Meal Menu response', error)
                    }
                )
            this.setState({ loading: true })
            get('/mealSchools/' + schoolId + '?access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                let _dataObj = data
                _dataObj.contactPPhone = (_dataObj.contactPPhone || '').substr(-this.state.mobileLength);
                _dataObj.principalPhone = (_dataObj.principalPhone || '').substr(-this.state.mobileLength);
                if(_dataObj.contactPEmail !== "" && _dataObj.contactPName !== "" && _dataObj.contactPPhone !== ""){
                    this.setState({
                        schoolLogo: data.logoLink,
                        loading: false,
                        mealSchoolInfo: _dataObj
                    }, () => {
                })
              }else{
                this.getManageSchools().then(manageSchools => {
                const mealSchoolInfo = {..._dataObj, ...manageSchools};
                this.setState({
                    schoolLogo: data.logoLink,
                    loading: false,
                    mealSchoolInfo: mealSchoolInfo
                    }, () => {
                }) })
            }})
                .catch(
                    (error) => {
                        this.setState({ loading: false })
                        console.log('Get school logo response', error)
                    }
                )
        }

         getManageSchools = () => {
                return getManageSchoolSettingList(sessionStorage.getItem('SchoolId')).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
                   const schoolListData = ((data._embedded || {}).schoolYears || []).find(col => {
                    const now = new Date();
                    const sd = new Date(col.sessionStartDateTime);
                    const ed = new Date(col.sessionEndDateTime);

                    return sd <= now && now <= ed;
                    });
                    if (!schoolListData) {
                    // return an object with explicit NO DATA markers so caller can handle it
                    return {
                       contactPName: 'NO data found',
                       contactPEmail: 'NO data found',
                       contactPPhone: 'NO data found',
                       benefitsPersonName: null,
                       benefitsPersonEmail: null,
                       benefitsPersonPhone: null
                    };
                }
                const { sessionStartDateTime, sessionEndDateTime } = schoolListData;
                // Normalize contact fields and use explicit NO data marker when missing
                schoolListData.contactPEmail = schoolListData.benefitsPersonEmail || 'NO data found';
                schoolListData.contactPName = schoolListData.benefitsPersonName || 'NO data found';
                schoolListData.contactPPhone = schoolListData.benefitsPersonPhone || 'NO data found';
                return schoolListData; 
                }).catch(error => {
                    console.log('Error fetching manage schools list:', error);
                });
            }

    handleSave = () => {
        this.setState({ loading: true });
         let payload = {
            editableBody: this.state.editableContent,
            closingTxt: this.state.sincerelyText
          };
        let headers = {
            'Content-Type': 'application/json'
        };
        // Simulate API call to save the template
        putWithHeadersResponse(`/updateEligibilityLetterSetting/${schoolId}?access_token=`, 
           JSON.stringify( payload), headers
        ).then(response => {
            this.setState({ loading: false });
            this._notificationSystem.addNotification({
                message: 'Eligibility letter template saved successfully',
                level: 'success'
            });
            this.getData(); // Refresh data after saving
        }).catch(error => {
            this.setState({ loading: false });
            this._notificationSystem.addNotification({
                message: 'Error saving eligibility letter template',
                level: 'error'
            });
        });
    };
   
   getData = () => {
    this.setState({loading:true});
    get(`/get/updatedEligibilityLetterSettings/${schoolId}?access_token=`).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }).then(data => {
        this.setState({
            editableContent: data.response.editableBody || '',
            sincerelyText: data.response.closingTxt || '',
            loading:false,
        });
       // window.location.reload();
    }).catch(error => {
        this.setState({loading:false});
        console.log('Error fetching eligibility letter settings:', error);
    });
   }

    render() {
        const loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo')) || {};
         const ms = this.state.mealSchoolInfo || {};
        const allNoData = (ms.contactPName === 'NO data found' && ms.contactPEmail === 'NO data found' && ms.contactPPhone === 'NO data found');
        if (allNoData) {
            return (
                <div style={{ padding: 40, textAlign: 'center' }}>
                  <div className="row"> 
                     <div className="alert alert-danger alert-dismissable" style={lunchProAlert.alert} role="alert">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button>
                           <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                            <span style={lunchProAlert.alertText}>
                              {'School Food Service Director and Fair Hearing Official is required. Go to Profile Details → Account to enter this information'}</span>
                            <span style={lunchProAlert.acceptSpan}>
                             <button type="button" className="btn btn-xs btn-primary" style={{margin: '0 0 9px 0', fontSize: '12px'}} onClick={(e)=>{
                              if (this.props.history && this.props.history.length > 1) this.props.history.goBack();
                                 else this.setState({ mealSchoolInfo: {} });                   
                                }}> <span>Close</span></button></span>
                       </div>
                    </div>
                </div>                        
            );
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader size={20} color={'#ea7066'} loading={this.state.loading} />
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-md-12 sectionTitle">
                            <h2><span>Edit Eligibility Letter</span></h2>
                        </div>
                    </div>

                    <div className="letter-wrapper">

                    {/* HEADER */}
                        <h4 className="text-center">{loginUserInfo.schoolName}</h4>
                        <h4 className="text-center">
                            NOTIFICATION LETTER FOR SCHOOL MEALS
                        </h4>
                        <hr/>
                    {/* BODY */}
                   <p>Dear Parent/Guardian,</p>

                   <p>This letter is a notification of meal benefits for the child(ren) listed below:</p>

                   <p><symbol>{'<'}</symbol> student name<symbol>{'>'}</symbol></p>

                   <p>Your child(ren) has been:</p>

                {/* APPROVED / DENIED SECTION */}
                <div className="row">
                    <div className="col-md-5">
                        <h5><b>Approved</b></h5>
                        <p>☐ Approved for free meals</p>
                        <p>☑ Approved for reduced-price meals at</p>
                        <p>$0.40 for lunch and $0.30 for breakfast</p>
                    </div>

                    <div className="col-md-5">
                        <h5><b>Denied</b></h5>
                        <p>☐ Income over the allowable amount</p>
                        <p>☐ SNAP/TANF/FDPIR case # invalid</p>
                        <p>☐ Incomplete application. The following is missing</p>
                        <p>☐ Other:</p>
                    </div>
                </div>

              {/* FIXED PARAGRAPH */}
                <textarea
                    value={this.state.editableContent || ''}
                    onChange={(e) => this.setState({ editableContent: e.target.value })}
                    style={{ width: '80%', marginTop: '20px', marginBottom: '20px' }}
                />
                <p>You also have the right to a fair hearing. This can be done by contacting the following official: <span className="yellow-text">{this.state.mealSchoolInfo.principalName} {this.state.mealSchoolInfo.principalPhone}, {this.state.mealSchoolInfo.principalEmail} </span></p> 
                <br/>
                <p>You are able to re-apply for free and reduced-price benefits at any time during the school year by completing another application.  </p>
                <br/>

            <div>
                <input
                    type="text"
                    value={this.state.sincerelyText || ''}
                    onChange={(e) => this.setState({ sincerelyText: e.target.value })}
                />
           </div>
            <p><span className="yellow-text">{this.state.mealSchoolInfo.contactPName}</span></p>
            <p><span className="yellow-text">{this.state.mealSchoolInfo.contactPPhone}</span></p>
            <p><span className="yellow-text">{this.state.mealSchoolInfo.contactPEmail}</span></p>

            {/* USDA CIVIL RIGHTS SECTION */}
        <div className="usda-section">
        <p><i>In accordance with federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, this institution is prohibited from  
discriminating on the basis of race, color, national origin, sex (including gender identity and sexual orientation), disability, age, or reprisal or retaliation for  
prior civil rights activity. </i></p>

        <p><i> Program information may be made available in languages other than English. Persons with disabilities who require alternative means of communication to  
obtain program information (e.g., Braille, large print, audiotape, American Sign Language), should contact the responsible state or local agency that  
administers the program or USDA's TARGET Center at (202) 720-2600 (voice and TTY) or contact USDA through the Federal Relay Service at (800) 877-8339.  </i></p>

        <p><i>To file a program discrimination complaint, a Complainant should complete a Form AD-3027, USDA Program Discrimination Complaint Form which can be  
obtained online at: https://www.usda.gov/sites/default/files/documents/ad-3027.pdf, from any USDA office, by calling (866) 632-9992, or by writing a letter  
addressed to USDA. The letter must contain the complainant's name, address, telephone number, and a written description of the alleged discriminatory action  
in sufficient detail to inform the Assistant Secretary for Civil Rights (ASCR) about the nature and date of an alleged civil rights violation. The completed AD
3027 form or letter must be submitted to USDA by: (1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400  
Independence Avenue, SW, Washington, D.C. 20250-9410; or (2) fax: (833) 256-1665 or (202) 690-7442; or (3) email: program.intake@usda.gov. This  
institution is an equal opportunity provider. </i> </p>
</div>

</div>


        {/* -------- SAVE BUTTON -------- */}
        <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-md-12 text-right">
                <button
                    className="btn btn-primary"
                    onClick={this.handleSave}
                >
                    Save Template
                </button>
            </div>
        </div>

    </div>

  </div>
        );
    }
}

export default withRouter(EditEligibilityLetter);



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/editEligibilityLetter/index.jsx